/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Files_Pagination_Page_CountInputs */

const es_settings_files_pagination_page_count = /** @type {(inputs: Settings_Files_Pagination_Page_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} archivo(s) en esta página`)
};

const en_settings_files_pagination_page_count = /** @type {(inputs: Settings_Files_Pagination_Page_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} file(s) on this page`)
};

/**
* | output |
* | --- |
* | "{count} file(s) on this page" |
*
* @param {Settings_Files_Pagination_Page_CountInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_pagination_page_count = /** @type {((inputs: Settings_Files_Pagination_Page_CountInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Pagination_Page_CountInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_pagination_page_count(inputs)
	return en_settings_files_pagination_page_count(inputs)
});
export { settings_files_pagination_page_count as "settings.files.pagination.page_count" }